export default {
    setVorgeschlageneDiagnose(state, vorgeschlageneDiagnose) {
        state.vorgeschlageneDiagnose = vorgeschlageneDiagnose
    },
    setBestaetigteDiagnose(state, bestaetigteDiagnose) {
        state.bestaetigteDiagnose = bestaetigteDiagnose
    },
    setDiagnoseConfirmed(state, flag) {
        state.diagnoseConfirmed = flag
    },
    setPatientIsPregnant(state, flag) {
        state.patientIsPregnant = flag
    },
    setBestaetigteDiagnoseSelected(state, flag) {
        state.bestaetigteDiagnoseSelected = flag
    },
    setPatientIsPregnantSelected(state, flag) {
        state.patientIsPregnantSelected = flag
    }
}